import { render, staticRenderFns } from "./AssessmentPeriodProjects.vue?vue&type=template&id=6c51ba64"
import script from "./assessment-period-projects.ts?vue&type=script&lang=ts&external"
export * from "./assessment-period-projects.ts?vue&type=script&lang=ts&external"
import style0 from "./assessment-period-projects.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports